/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import { useMemo } from 'react'

import { Link } from 'react-router-dom'

import { useFragment } from 'react-relay'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { Card } from '@pareto-engineering/design-system'

import { TimeToRead, CategoryButton } from 'modules/components'

import { useBlog } from '../Context'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'article-card'

const wrapperClassName = 'article-card-wrapper'

const ARTICLE_FRAGMENT = graphql`
  fragment ArticleCardFragment on PublicBlogPostNode {
    id
    slug
    title
    description
    mainImage
    wordCount
    category {
      ...CategoryButtonFragment
    }
  }
`

/**
 * This is the component description.
 */
const ArticleCard = ({
  id,
  className:userClassName,
  style,
  node,
}) => {
  const {
    generateBlogPath,
  } = useBlog()

  const fragment = useFragment(
    ARTICLE_FRAGMENT,
    node,
  )

  const {
    slug,
    title,
    description,
    mainImage,
    category,
    wordCount,
  } = fragment

  const url = useMemo(() => generateBlogPath(
    'SINGLE',
    { slug },
  ), [slug])

  return (
    <Link
      className={[
        baseClassName,
        wrapperClassName,
        userClassName,
      ]
        .filter((e) => e)
        .join(' ')}
      to={url}
    >
      <Card
        id={id}
        className={[
          baseClassName,
          componentClassName,
        ]
          .filter((e) => e)
          .join(' ')}
        style={style}
      >
        <Card.Section className="image-header" isImage>
          <img src={mainImage} alt={description || title} />
        </Card.Section>
        <Card.Section className="title">
          <p className="h3">
            {title}
          </p>
        </Card.Section>
        <Card.Section className="data">
          {
            category && (
              <CategoryButton
                color="interactive"
                node={category}
              />
            )
          }
          {
            wordCount && (
              <TimeToRead
                wordCount={wordCount}
              />
            )
          }
        </Card.Section>
      </Card>
    </Link>
  )
}

ArticleCard.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The ref to the query
   */
  node:PropTypes.node,
}

ArticleCard.defaultProps = {
  // someProp:false
}

ArticleCard.Group = Card.Group

export default ArticleCard
